export default "__VITE_ASSET__f82c377c__"